import { useMutation } from '@tanstack/react-query';

import { exportOrderAsPdf } from '../../../../common/api/clients/export.api';

export const useExportOrderMutation = () => {
    return useMutation({ mutationFn: exportOrderAsPdf });
};
